import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { WorkspaceTabOwnProps } from 'shared/connect/connect';
import { cancelQuoteByWorkspaceThunk } from 'state/quotes/quotes.thunks';
import { ThunkDispatch } from 'state/state.common';

interface DispatchProps {
  onCancel: () => void;
}
interface Props extends DispatchProps {
  context: string;
  className?: string;
}

export function CancelButton({ onCancel, context, className }: Props) {
  return (
    <div className={className}>
      <button
        className={classNames('btn btn-xl btn-light w-100')}
        data-e2e={`cancel-${context}`}
        id={`btn-cancel-${context}`}
        onClick={onCancel}
        type="button"
      >
        <FormattedMessage id="form.buttons.Cancel" />
      </button>
    </div>
  );
}
const mapDispatchPropsCancelQuote = (dispatch: ThunkDispatch, { formId, workspace }: WorkspaceTabOwnProps) => ({
  onCancel: () => {
    dispatch(cancelQuoteByWorkspaceThunk(formId, workspace));
  },
});

export const CancelQuoteButtonConnected = connect(
  () => ({ context: 'quote' }),
  mapDispatchPropsCancelQuote,
)(CancelButton);
